// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FBEP","placeholdersHeader":"styles_placeholdersHeader__18AbR","editorStyle":"styles_editorStyle__23h78","placeholdersBox":"styles_placeholdersBox__2J42t"};